module.exports = __webpack_public_path__ + "img/9791130600093.01b6fe75.jpg";